window.BILLING = {
    layers: {
        balance_value: $('#screens .screen.billing .block.balance .balance-state .balance-state-value span'),
        add_balance: {
            form: $('#screens .screen.billing .block.balance .balance-add form'),
            form_value_input: $('#screens .screen.billing .block.balance .balance-add form input')
        },

        add_balance_window: {
            window: $('#balance-add-window'),
            cross: $('#balance-add-window .balance-add-window-title .cross'),
            title_value: $('#balance-add-window .balance-add-window-title .title span'),

            liqpay: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.liqpay'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.liqpay .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.liqpay .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.liqpay .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.liqpay .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            },

            idram: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.idram'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.idram .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.idram .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.idram .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.idram .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            },

            fashshift: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.fastshift'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.fastshift .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.fastshift .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.fastshift .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.fastshift .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            },

            idBank: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.idBank'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.idBank .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.idBank .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.idBank .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.idBank .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            },

            tinkoff: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.tinkoff'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.tinkoff .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.tinkoff .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.tinkoff .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.tinkoff .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            },

            tbc: {
                item: $('#balance-add-window .balance-add-window-content .balance-add-item.tbcbank'),
                add_money_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.tbcbank .balance-add-item-content .balance-add-item-money span'),
                add_money_amount_full: $('#balance-add-window .balance-add-window-content .balance-add-item.tbcbank .balance-add-item-content .balance-add-item-full-amount span'),
                add_money_submit: $('#balance-add-window .balance-add-window-content .balance-add-item.tbcbank .balance-add-item-content .balance-add-item-pay button span'),
                input_amount: $('#balance-add-window .balance-add-window-content .balance-add-item.tbcbank .balance-add-item-content .balance-add-item-pay form input[name=amount]')
            }
        },

        add_balance_results_window: {
            window: $('#balance-payment-result'),
            cross: $('#balance-payment-result .balance-payment-result-title .cross'),
            back: $('#balance-payment-result .balance-payment-result-value .result-block .btn button')
        },

        add_balance_map_window: {
            window: $('.zero-balance-map'),
            form: $('.zero-balance-map form'),
            form_value_input: $('.zero-balance-map form input'),
            skip: $('.zero-balance-map .skip button')
        },

        active_transaction_window: {
            window: $('#active-transaction-window'),
            cross: $('#active-transaction-window .active-transaction-window-title .cross'),
            btn: $('#screens .screen.billing .block.active-transactions .active-transactions-list'),
            btn_selector: '#screens .screen.billing .block.active-transactions .active-transactions-list .active-transactions-list-item .active-transactions-list-content .details button',
            mab_btn: $('.active-transaction-map')
        },

        full_transaction_history: {
            btn: $('#screens .screen.billing .block.transactions-history .more button'),
            window: $('#balance-transactions-history'),
            cross: $('#balance-transactions-history .balance-transactions-history-title .cross'),
            form: $('#balance-transactions-history .balance-transactions-history-content .block.timing form'),
            form_submit_btn: $('#balance-transactions-history .balance-transactions-history-content .block.timing form button'),
            date_from: $('#balance-transactions-history .balance-transactions-history-content .block.timing form input[name=from]'),
            date_to: $('#balance-transactions-history .balance-transactions-history-content .block.timing form input[name=to]'),
            empty_list: $('#balance-transactions-history .balance-transactions-history-content .block.history .empty'),
            list: $('#balance-transactions-history .balance-transactions-history-content .block.history .list')
        },

        active_transaction: {
            chart: false,
            chart_layer: $('#active-transaction-window .active-transaction-window-content .chart'),
            number: $('#active-transaction-window .active-transaction-window-title .title span'),
            price: $('#active-transaction-window .active-transaction-window-content .block.amount .amount-value span'),
            soc: $('#active-transaction-window .active-transaction-window-content .block.buttery .buttery-value .buttery-value-percent'),
            soc_block: $('#active-transaction-window .active-transaction-window-content .block.buttery'),
            soc_text: $('#active-transaction-window .active-transaction-window-content .block.buttery .buttery-value .buttery-value-percent span.text'),
            soc_color: $('#active-transaction-window .active-transaction-window-content .block.buttery .buttery-value .buttery-value-percent span.color'),
            speed: {
                block: $('#active-transaction-window .active-transaction-window-content .block .item.speed'),
                value: $('#active-transaction-window .active-transaction-window-content .block .item.speed .item-value span')
            },
            charged: {
                block: $('#active-transaction-window .active-transaction-window-content .block .item.kwh'),
                value: $('#active-transaction-window .active-transaction-window-content .block .item.kwh .item-value span')
            },
            time: {
                block: $('#active-transaction-window .active-transaction-window-content .block .item.time'),
                value: $('#active-transaction-window .active-transaction-window-content .block .item.time .item-value')
            },
            voltage: {
                block: $('#active-transaction-window .active-transaction-window-content .block .item.voltage'),
                value: $('#active-transaction-window .active-transaction-window-content .block .item.voltage .item-value span')
            },
            ampere: {
                block: $('#active-transaction-window .active-transaction-window-content .block .item.ampere'),
                value: $('#active-transaction-window .active-transaction-window-content .block .item.ampere .item-value span')
            },
            stop_btn: $('#active-transaction-window .active-transaction-window-content .stop-transaction button'),
            charger_stop_btn: $('#charger-window .charger-content .connectors .connector .description .line2 .btns button.stop-transaction'),
            charger: {
                number: $('#active-transaction-window .active-transaction-window-content .block.charger .icon .status span'),
                name: $('#active-transaction-window .active-transaction-window-content .block.charger .description .name'),
                adress: $('#active-transaction-window .active-transaction-window-content .block.charger .description .adress'),
                connector: $('#active-transaction-window .active-transaction-window-content .block.charger .description .connector-type')
            },
            tariff: {
                pkWh: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.perkWwh'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.perkWwh .item-value span')
                },
                pkWh_night: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.perkWwh-night'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.perkWwh-night .item-value span')
                },
                parking: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.parking'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.parking .item-value span')
                },
                parking_night: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.parking-night'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.parking-night .item-value span')
                },
                ph: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.perMin'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.perMin .item-value span')
                },
                ph_night: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.perMin-night'),
                    value: $('#active-transaction-window .active-transaction-window-content .block .item.perMin-night .item-value span')
                },
                free: {
                    block: $('#active-transaction-window .active-transaction-window-content .block .item.free')
                }
            }
        },

        active_transactions: {
            block: $('#screens .screen.billing .block.active-transactions'),
            list: $('#screens .screen.billing .block.active-transactions .active-transactions-list')
        },

        load: $('#load')
    },

    init: async () => {
        window.BILLING.layers.add_balance.form.submit(function () {

            if($(this).hasClass('pay-by-card')) {

                return true;

            } else {
                var amount = parseFloat(window.BILLING.layers.add_balance.form_value_input.val());

                if (amount >= parseInt(window.BILLING.layers.add_balance.form_value_input.attr('min')) && amount <= parseInt(window.BILLING.layers.add_balance.form_value_input.attr('max'))) {
                    window.BILLING.open_add_balance_window(amount);
                }

                return false;
            }
        });

        if(window.BILLING.layers.add_balance_map_window.window.length > 0) {
            setTimeout(function () {
                if(!window.BILLING.layers.add_balance_map_window.window.hasClass('active')) {
                    window.BILLING.layers.add_balance_map_window.window.addClass('active');
                }
            }, 1000);
        }

        window.BILLING.layers.add_balance_map_window.form.submit(function () {
            var amount = parseFloat(window.BILLING.layers.add_balance_map_window.form_value_input.val());
            if(amount >= parseInt(window.BILLING.layers.add_balance_map_window.form_value_input.attr('min')) && amount <= parseInt(window.BILLING.layers.add_balance_map_window.form_value_input.attr('max'))) {
                window.BILLING.open_add_balance_window(amount);
            }
            return false;
        });

        window.BILLING.layers.add_balance_window.cross.click(function () {
            if(window.BILLING.layers.add_balance_window.window.hasClass('active')) {
                window.BILLING.layers.add_balance_window.window.removeClass('active');
            }
        });

        window.BILLING.layers.active_transaction_window.cross.click(function () {
            if(window.BILLING.layers.active_transaction_window.window.hasClass('active')) {
                window.BILLING.layers.active_transaction_window.window.removeClass('active');
                window.WS.transaction_unsubscribe(window.BILLING.layers.active_transaction_window.window.attr('data-id'));
            }
        });

        window.BILLING.layers.active_transaction_window.btn.on('click', '.details button', function () {
            if(!window.BILLING.layers.load.hasClass('active')) {
                window.BILLING.layers.load.addClass('active');
            }
            window.WS.transaction_subscribe($(this).attr('data-pk'));
        });

        window.BILLING.layers.active_transaction_window.mab_btn.click(function () {
            if($(this).attr('data-count') == 1) {
                if(!window.BILLING.layers.load.hasClass('active')) {
                    window.BILLING.layers.load.addClass('active');
                }
                window.WS.transaction_subscribe($(this).attr('data-pk'));
            } else {
                window.MENU.layers.items.billing.click();
            }
        });

        window.BILLING.layers.full_transaction_history.btn.click(function () {
            if(!window.BILLING.layers.full_transaction_history.window.hasClass('active')) {
                window.BILLING.layers.full_transaction_history.window.addClass('active');
            }

            window.BILLING.layers.full_transaction_history.form_submit_btn.click();
        });

        window.BILLING.layers.full_transaction_history.form.submit(function () {
            if(!window.BILLING.layers.load.hasClass('active')) {
                window.BILLING.layers.load.addClass('active');
            }

            window.WS.full_transactions_history(window.BILLING.layers.full_transaction_history.date_from.val(), window.BILLING.layers.full_transaction_history.date_to.val());
            return false;
        });

        window.BILLING.layers.full_transaction_history.cross.click(function () {
            if(window.BILLING.layers.full_transaction_history.window.hasClass('active')) {
                window.BILLING.layers.full_transaction_history.window.removeClass('active');
            }

            if(window.BILLING.layers.full_transaction_history.empty_list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.empty_list.removeClass('hide');
            }

            if(!window.BILLING.layers.full_transaction_history.list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.list.addClass('hide');
                window.BILLING.layers.full_transaction_history.list.html('');
            }
        });

        window.BILLING.layers.add_balance_results_window.cross.click(function () {
            if(window.BILLING.layers.add_balance_results_window.window.hasClass('active')) {
                window.BILLING.layers.add_balance_results_window.window.removeClass('active');
            }
        });

        window.BILLING.layers.add_balance_results_window.back.click(function () {
            window.BILLING.layers.add_balance_results_window.cross.click();
        });


        window.BILLING.layers.add_balance_map_window.skip.click(function () {
            if(window.BILLING.layers.add_balance_map_window.window.hasClass('active')) {
                window.BILLING.layers.add_balance_map_window.window.removeClass('active');
            }
            window.WS.skip_min_balance();
        });

        window.BILLING.layers.active_transaction.stop_btn.click(function () {
            if (window.confirm(window.confirm_stop_transaction)){
                window.WS.stop_transaction($(this).attr('data-id'));

                if (!window.CHARGER.layers.load.hasClass('active')) {
                    window.CHARGER.layers.load.addClass('active');
                }
            }
        });
        window.BILLING.layers.active_transaction.charger_stop_btn.click(function () {
            if (window.confirm(window.confirm_stop_transaction)){
                window.WS.stop_transaction($(this).attr('data-id'));
            }
        });

        if(window.BILLING.layers.add_balance_results_window.window.length > 0 && window.BILLING.layers.add_balance_results_window.window.hasClass('active')) {
            setTimeout(function () {
                if(window.BILLING.layers.add_balance_results_window.window.hasClass('active')) {
                    window.BILLING.layers.add_balance_results_window.cross.click();
                }
            }, 5000);
        }
    },

    open_transaction_window: async (data, open_page) => {
        var number = '№'+ data.id;
        if(number != window.BILLING.layers.active_transaction.number.html()) {
            window.BILLING.layers.active_transaction.number.html(number);
        }

        window.BILLING.layers.active_transaction_window.window.attr('data-id', data.id);

        window.BILLING.layers.active_transaction.stop_btn.attr('data-id', data.id);

        if(data.amount != window.BILLING.layers.active_transaction.price.html()) {
            window.BILLING.layers.active_transaction.price.html(data.amount);
        }

        if(data.soc != window.BILLING.layers.active_transaction.soc_text.html()) {
            window.BILLING.layers.active_transaction.soc_text.html(data.soc +'%');
            window.BILLING.layers.active_transaction.soc_color.css('width', data.soc +'%');
        }
        if(data.soc > 0) {
            if(window.BILLING.layers.active_transaction.soc_block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.soc_block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.soc_block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.soc_block.addClass('hide');
            }
        }

        if(data.power > 0) {
            if(data.power != window.BILLING.layers.active_transaction.speed.value.html()) {
                window.BILLING.layers.active_transaction.speed.value.html(data.power);
            }

            if(window.BILLING.layers.active_transaction.speed.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.speed.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.speed.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.speed.block.addClass('hide');
            }
        }

        if(data.charged > 0) {
            if(data.charged != window.BILLING.layers.active_transaction.charged.value.html()) {
                window.BILLING.layers.active_transaction.charged.value.html(data.charged);
            }

            if(window.BILLING.layers.active_transaction.charged.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.charged.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.charged.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.charged.block.addClass('hide');
            }
        }

        if(data.time != '') {
            if(data.time != window.BILLING.layers.active_transaction.time.value.html()) {
                window.BILLING.layers.active_transaction.time.value.html(data.time);
            }

            if(window.BILLING.layers.active_transaction.time.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.time.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.time.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.time.block.addClass('hide');
            }
        }

        if(data.voltage != '') {
            if(data.voltage != window.BILLING.layers.active_transaction.voltage.value.html()) {
                window.BILLING.layers.active_transaction.voltage.value.html(data.voltage);
            }

            if(window.BILLING.layers.active_transaction.voltage.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.voltage.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.voltage.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.voltage.block.addClass('hide');
            }
        }

        if(data.ampere != '') {
            if(data.ampere != window.BILLING.layers.active_transaction.ampere.value.html()) {
                window.BILLING.layers.active_transaction.ampere.value.html(data.ampere);
            }

            if(window.BILLING.layers.active_transaction.ampere.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.ampere.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.ampere.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.ampere.block.addClass('hide');
            }
        }

        window.BILLING.layers.active_transaction.charger.number.html(data.charger.number);
        window.BILLING.layers.active_transaction.charger.name.html(data.charger.name);
        window.BILLING.layers.active_transaction.charger.adress.html(data.charger.adress);
        window.BILLING.layers.active_transaction.charger.connector.html(data.charger.connector);

        var tariff_free = true;
        if(data.tafiff.pkWh > 0) {
            tariff_free = false;

            if(data.tafiff.pkWh != window.BILLING.layers.active_transaction.tariff.pkWh.value.html() && window.country != 'armenia') {
                window.BILLING.layers.active_transaction.tariff.pkWh.value.html(data.tafiff.pkWh);
            }

            if(window.BILLING.layers.active_transaction.tariff.pkWh.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.pkWh.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.pkWh.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.pkWh.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.pkWh.value.html();
            }
        }
        if(data.tafiff.pkWh_night > 0) {
            tariff_free = false;

            if(data.tafiff.pkWh_night != window.BILLING.layers.active_transaction.tariff.pkWh_night.value.html()) {
                window.BILLING.layers.active_transaction.tariff.pkWh_night.value.html(data.tafiff.pkWh_night);
            }

            if(window.BILLING.layers.active_transaction.tariff.pkWh_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.pkWh_night.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.pkWh_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.pkWh_night.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.pkWh_night.value.html();
            }
        }
        if(data.tafiff.parking > 0) {
            tariff_free = false;

            if(data.tafiff.parking != window.BILLING.layers.active_transaction.tariff.parking.value.html()) {
                window.BILLING.layers.active_transaction.tariff.parking.value.html(data.tafiff.parking);
            }

            if(window.BILLING.layers.active_transaction.tariff.parking.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.parking.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.parking.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.parking.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.parking.value.html();
            }
        }
        if(data.tafiff.parking_night > 0) {
            tariff_free = false;

            if(data.tafiff.parking_night != window.BILLING.layers.active_transaction.tariff.parking_night.value.html()) {
                window.BILLING.layers.active_transaction.tariff.parking_night.value.html(data.tafiff.parking_night);
            }

            if(window.BILLING.layers.active_transaction.tariff.parking_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.parking_night.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.parking_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.parking_night.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.parking_night.value.html();
            }
        }
        if(data.tafiff.ph > 0) {
            tariff_free = false;

            if(data.tafiff.ph != window.BILLING.layers.active_transaction.tariff.ph.value.html()) {
                window.BILLING.layers.active_transaction.tariff.ph.value.html(data.tafiff.ph);
            }

            if(window.BILLING.layers.active_transaction.tariff.ph.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.ph.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.ph.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.ph.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.ph.value.html();
            }
        }
        if(data.tafiff.ph_night > 0) {
            tariff_free = false;

            if(data.tafiff.ph_night != window.BILLING.layers.active_transaction.tariff.ph_night.value.html()) {
                window.BILLING.layers.active_transaction.tariff.ph_night.value.html(data.tafiff.ph_night);
            }

            if(window.BILLING.layers.active_transaction.tariff.ph_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.ph_night.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.ph_night.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.ph_night.block.addClass('hide');
                window.BILLING.layers.active_transaction.tariff.ph_night.value.html();
            }
        }

        if(data.power_history.length > 2) { /* HERE */
            if(window.BILLING.layers.active_transaction.chart == false) {

                window.BILLING.layers.active_transaction.chart = Highcharts.chart('active-transaction-power-chart', {
                    chart: {
                        type: 'areaspline'
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        type: 'datetime'
                    },
                    yAxis: [{
                        title: {
                            text: ''
                        },
                        labels: {
                            enabled: false
                        },
                    }],
                    plotOptions: {
                        area: {
                            marker: {
                                enabled: false,
                                symbol: 'circle',
                                radius: 2,
                                states: {
                                    hover: {
                                        enabled: true
                                    }
                                }
                            }
                        }
                    },
                    tooltip: {
                        borderRadius: 10,
                        borderWidth: 3,
                        className: 'highcharts-tooltip',
                        formatter: function () {
                            return '<b>' + this.y + '</b> ' + this.series.name;
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    series: [{
                        name: window.kW ,
                        data: data.power_history
                    }]
                });
            } else {
                window.BILLING.layers.active_transaction.chart.update({
                    series: [{
                        name: window.kW ,
                        data: data.power_history
                    }]
                });
            }

            if(window.BILLING.layers.active_transaction.chart_layer.hasClass('hide')) {
                window.BILLING.layers.active_transaction.chart_layer.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.chart_layer.hasClass('hide')) {
                window.BILLING.layers.active_transaction.chart_layer.addClass('hide');
                window.BILLING.layers.active_transaction.chart = false;
            }
        }

        if(tariff_free) {
            if(window.BILLING.layers.active_transaction.tariff.free.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.free.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transaction.tariff.free.block.hasClass('hide')) {
                window.BILLING.layers.active_transaction.tariff.free.block.addClass('hide');
            }
        }

        if(!window.BILLING.layers.active_transaction_window.window.hasClass('active') && open_page == true) {
            window.BILLING.layers.active_transaction_window.window.addClass('active');
        }

        if(window.BILLING.layers.load.hasClass('active')) {
            window.BILLING.layers.load.removeClass('active');
        }
    },

    transactin_history_list: async (data) => {
        if(data.length > 0) {
            if(!window.BILLING.layers.full_transaction_history.empty_list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.empty_list.addClass('hide');
            }

            var HTML = '';
            $.each(data, function (index, item) {
                switch (item.type) {
                    case "manual":
                    case "refill_w4p":
                    case "refill_liqpay":
                    case "refill_tinkoff":
                    case "refill_iDram":
                    case "refill_fastShift":
                    case "refill_idBank":
                    case "refill_TBCBank":
                        HTML += '<div class="history-list-item"><div class="history-list-item-date">'+ item.date +'</div><div class="history-list-item-amount '+ item.class +'"><span>'+ item.money +'</span> '+ window.currency +'</div><div class="history-list-item-description">'+ item.description +'</div></div>';
                    break;
                    case "transaction":
                    case "transaction_amount_plan":
                    case "cashback":
                    case "book_30min":
                    case "book_45min":
                    case "book_1h":
                    case "cashback_referral":
                    case "cashback_10kWh":
                    case "cashback_100kWh":
                        HTML += '<div class="history-list-item"><div class="history-list-item-date">'+ item.date +'</div><div class="history-list-item-amount '+ item.class +'"><span>'+ item.money +'</span> '+ window.currency +'</div><div class="history-list-item-description">'+ item.description +'</div>';

                        if(item.sub_data > 0) {
                            HTML += '<div class="history-list-item-tags">';
                            $.each(item.sub_data, function (index_in, item_in) {
                                HTML += '<span>'+ item_in +'</span>';
                            });
                            HTML += '</div>';
                        }

                        HTML += '</div>';
                    break;
                }
            });

            window.BILLING.layers.full_transaction_history.list.html(HTML);

            if(window.BILLING.layers.full_transaction_history.list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.list.removeClass('hide');
            }
        } else {
            if(window.BILLING.layers.full_transaction_history.empty_list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.empty_list.removeClass('hide');
            }

            if(!window.BILLING.layers.full_transaction_history.list.hasClass('hide')) {
                window.BILLING.layers.full_transaction_history.list.addClass('hide');
                window.BILLING.layers.full_transaction_history.list.html('');
            }
        }

        if(window.BILLING.layers.load.hasClass('active')) {
            window.BILLING.layers.load.removeClass('active');
        }
    },

    update_transaction_soc: async (data) => {
        if($('.active-transaction-map.active[data-pk='+ data.id +']').length > 0) {
            var soc = $('.active-transaction-map[data-pk='+ data.id +'] span').html();

            var in_soc = data.soc +'%';
            if(soc != in_soc) {
                $('.active-transaction-map[data-pk='+ data.id +'] span').html(in_soc);
            }
        }
    },

    stop_transaction: async (data) => {
        if($('.active-transaction-map.active[data-pk='+ data.id +']').length > 0) {
            $('.active-transaction-map[data-pk='+ data.id +']').removeClass('active');
        }

        if($('#active-transaction-window.active[data-id='+ data.id +']').length > 0) {
            $('#active-transaction-window.active[data-id='+ data.id +'] .cross').click();
        }

        window.BILLING.update_active_transactions(data.active_transactions);

        if(window.CHARGER.layers.load.hasClass('active')) {
            window.CHARGER.layers.load.removeClass('active');
        }
    },

    start_transaction: async (data) => {
        window.BILLING.update_active_transactions(data.active_transactions);
        $(window.BILLING.layers.active_transaction_window.btn_selector +'[data-pk='+ data.id +']').click();

        var map_btn = $('.active-transaction-map');
        if(!map_btn.hasClass('active')) {

            map_btn.attr('data-pk', data.id);
            map_btn.attr('data-count', data.active_transactions.data.length);

            if(data.soc > 0) {
                var in_soc = data.soc + '%';
                map_btn.find('span').html(in_soc);
            } else {
                map_btn.find('span').html('');
            }

            map_btn.addClass('active');
        }

        if(window.CHARGER.layers.load.hasClass('active')) {
            window.CHARGER.layers.load.removeClass('active');
        }
        if(window.CHARGER.timer.start_transaction !== false) {
            clearTimeout(window.CHARGER.timer.start_transaction);
            window.CHARGER.timer.start_transaction = false;
        }

        window.CHARGER.layers.cross.click();
    },

    update_active_transactions: async (data) => {
        if(data.data.length > 0) {
            var HTML = '';

            $.each(data.data, function (index, transaction) {
                HTML += '<div class="active-transactions-list-item"><div class="active-transactions-list-icon"><i class="fad fa-charging-station"></i><div class="number">№'+ transaction.id +'</div></div><div class="active-transactions-list-content"><div class="name">'+ transaction.title +'</div><div class="adress">'+ transaction.adress +'</div><div class="details"><button class="uk-button uk-button-primary" data-pk="'+ transaction.id +'">'+ data.details +'</button></div></div><div class="clear"></div></div>';
            });

            window.BILLING.layers.active_transactions.list.html(HTML);
            if(window.BILLING.layers.active_transactions.block.hasClass('hide')) {
                window.BILLING.layers.active_transactions.block.removeClass('hide');
            }
        } else {
            if(!window.BILLING.layers.active_transactions.block.hasClass('hide')) {
                window.BILLING.layers.active_transactions.block.addClass('hide');
                window.BILLING.layers.active_transactions.list.html('');
            }
        }
    },

    open_add_balance_window: async (amount) => {

        if(amount > 0 && amount <= 100000) {
            window.BILLING.layers.add_balance_window.title_value.html(amount +' '+ window.currency);

            if(window.BILLING.layers.add_balance_window.liqpay.item.length > 0) {

                window.BILLING.layers.add_balance_window.liqpay.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.liqpay.add_money_amount_full.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.liqpay.add_money_submit.html(amount);
                window.BILLING.layers.add_balance_window.liqpay.input_amount.val(amount);

            }

            if(window.BILLING.layers.add_balance_window.idram.item.length > 0) {

                window.BILLING.layers.add_balance_window.idram.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.idram.add_money_amount_full.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.idram.add_money_submit.html(amount);
                window.BILLING.layers.add_balance_window.idram.input_amount.val(amount);

            }

            if(window.BILLING.layers.add_balance_window.fashshift.item.length > 0) {

                window.BILLING.layers.add_balance_window.fashshift.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.fashshift.add_money_amount_full.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.fashshift.add_money_submit.html(amount);
                window.BILLING.layers.add_balance_window.fashshift.input_amount.val(amount);

            }

            if(window.BILLING.layers.add_balance_window.idBank.item.length > 0) {

                window.BILLING.layers.add_balance_window.idBank.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.idBank.add_money_amount_full.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.idBank.add_money_submit.html(amount);
                window.BILLING.layers.add_balance_window.idBank.input_amount.val(amount);

            }

            if(window.BILLING.layers.add_balance_window.tinkoff.item.length > 0) {

                window.BILLING.layers.add_balance_window.tinkoff.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.tinkoff.add_money_amount_full.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.tinkoff.add_money_submit.html(amount);
                window.BILLING.layers.add_balance_window.tinkoff.input_amount.val(amount);

            }

            if(window.BILLING.layers.add_balance_window.tbc.item.length > 0) {

                var full_amount = amount + (amount * 0.02);
                full_amount = full_amount.toFixed(2);

                window.BILLING.layers.add_balance_window.tbc.add_money_amount.html(amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.tbc.add_money_amount_full.html(full_amount + ' ' + window.currency);
                window.BILLING.layers.add_balance_window.tbc.add_money_submit.html(full_amount);
                window.BILLING.layers.add_balance_window.tbc.input_amount.val(amount);

            }

            if (!window.BILLING.layers.add_balance_window.window.hasClass('active')) {
                window.BILLING.layers.add_balance_window.window.addClass('active');
            }
        }
    }
};
window.BILLING.init();
